import React from 'react';
import Icon from 'components/AppIcon';


const METRICS = [
  { value: 'revenue', label: 'Revenue', icon: 'DollarSign' },
  { value: 'volume', label: 'Volume', icon: 'Package' },
  { value: 'accounts', label: 'Accounts', icon: 'Users' },
];

const TIME_PERIODS = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'quarter', label: 'This Quarter' },
  { value: 'year', label: 'This Year' },
];

export default function MapControls({ activeMetric, setActiveMetric, timePeriod, setTimePeriod, zoom, onZoomIn, onZoomOut, onReset }) {
  return (
    <div className="flex flex-col gap-3">
      {/* Metric Toggle */}
      <div className="rounded-lg p-3" style={{ background: 'var(--color-muted)', border: '1px solid var(--color-border)' }}>
        <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Layer</p>
        <div className="flex flex-col gap-1">
          {METRICS?.map((m) => (
            <button
              key={m?.value}
              onClick={() => setActiveMetric(m?.value)}
              className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-caption transition-all duration-200 press-effect min-h-[36px]`}
              style={activeMetric === m?.value ? { background: 'linear-gradient(135deg, #DC2626, #B91C1C)', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)' } : { color: 'var(--color-muted-foreground)' }}
            >
              <Icon name={m?.icon} size={14} color="currentColor" strokeWidth={2} />
              <span>{m?.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Time Period */}
      <div className="rounded-lg p-3" style={{ background: 'var(--color-muted)', border: '1px solid var(--color-border)' }}>
        <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Period</p>
        <div className="flex flex-col gap-1">
          {TIME_PERIODS?.map((t) => (
            <button
              key={t?.value}
              onClick={() => setTimePeriod(t?.value)}
              className={`px-3 py-2 rounded-md text-sm font-caption text-left transition-all duration-200 press-effect min-h-[36px]`}
              style={timePeriod === t?.value ? { background: 'linear-gradient(135deg, #DC2626, #B91C1C)', color: '#FFFFFF', boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)' } : { color: 'var(--color-muted-foreground)' }}
            >
              {t?.label}
            </button>
          ))}
        </div>
      </div>
      {/* Zoom Controls */}
      <div className="rounded-lg p-3" style={{ background: 'var(--color-muted)', border: '1px solid var(--color-border)' }}>
        <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Zoom</p>
        <div className="flex flex-col gap-1">
          <button
            onClick={onZoomIn}
            className="flex items-center justify-center w-full h-9 rounded-md border border-border text-muted-foreground hover:bg-muted transition-all duration-200 press-effect"
            aria-label="Zoom in"
          >
            <Icon name="Plus" size={16} color="currentColor" strokeWidth={2} />
          </button>
          <div className="text-center font-data text-xs text-muted-foreground py-1">{zoom}%</div>
          <button
            onClick={onZoomOut}
            className="flex items-center justify-center w-full h-9 rounded-md border border-border text-muted-foreground hover:bg-muted transition-all duration-200 press-effect"
            aria-label="Zoom out"
          >
            <Icon name="Minus" size={16} color="currentColor" strokeWidth={2} />
          </button>
          <button
            onClick={onReset}
            className="flex items-center justify-center w-full h-9 rounded-md border border-border text-muted-foreground hover:bg-muted transition-all duration-200 press-effect mt-1"
            aria-label="Reset zoom"
          >
            <Icon name="Maximize2" size={14} color="currentColor" strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
}